// Investment codes end in a running number: <bank>/<reg>/<type>/<year>/00012.
// The next number is one past the highest already used, so a deleted
// investment never frees its number for someone else to reuse.
export function nextInvestmentNumber(investments = []) {
  const highest = investments.reduce((max, inv) => {
    const last = Number(String(inv?.code || "").split("/").pop());
    return Number.isFinite(last) && last > max ? last : max;
  }, 0);
  return String(highest + 1).padStart(4, "0");
}
